import { useEffect, useState } from "react";
import { Answer, GameState, IQScore, Question } from "../../types/iq-game-types";
import { IQCategory } from "./IQGameV2";

export const buildInitPage = (introThumb: string | undefined, onStart: () => void) => (
  <div className="game-on">
    <figure className="icon">{introThumb && <img src={introThumb} />}</figure>
    <div className="title"> IQ Test Game</div>
    <button type="button" onClick={(e) => onStart()}>
      START
    </button>
  </div>
);

export const QuestionScreen: React.FC<{
  question: Question;
  onNext: (selectedOption: Answer) => void;
}> = ({ question, onNext }) => {
  const [selectedOption, setSelectedOption] = useState<Answer | null>(null);
  const answerLetters = ["A", "B", "C", "D"];
  // console.log("getting into question screen");

  const handleSelectOption = (option: Answer) => {
    setSelectedOption(option);
    onNext(option);
  };

  return (
    <>
      <div className="game-q" style={{ backgroundImage: `url(${question.thumb.url})` }}></div>
      <div className="game-title">{question.title}</div>
      <div className="game-a-wrap">
        {question.answers.map((option, i) => (
          <div className="a-inner-wrap" key={option._id} onClick={() => handleSelectOption(option)}>
            <div className="num">{answerLetters[i]}</div>
            <div className="game-a" ng-click="updateSelection(1)">
              <img className="a-img 1" src={option.thumb.url} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

interface GameHeaderProps {
  colorTheme: string;
  categoryTitle: string;
  time: number;
  currentQuestionIndex: number;
  totalCount: number;
}

export const GameHeader: React.FC<GameHeaderProps> = ({
  colorTheme,
  categoryTitle,
  time,
  currentQuestionIndex,
  totalCount,
}) => {
  return (
    <div className="game-progress">
      <div className="current d-flex flex-row justify-content-between">
        <div className="type" style={{ color: colorTheme }}>
          {categoryTitle.toUpperCase()}
        </div>
        <div className="timer">
          <span>{buildTime(time)}</span>
        </div>
        <div className="stopwatch">
          <div className="question">
            {currentQuestionIndex}/{totalCount}
          </div>
        </div>
      </div>
      <div className="inner-progress w-100 d-flex">
        <div
          className="memory"
          style={{ width: `${(currentQuestionIndex / totalCount) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

interface buildResultsPageProps {
  gameScore: IQScore;
  time: number;
  categories: IQCategory[];
  gameState: GameState;
}

export const BuildResultsPage: React.FC<buildResultsPageProps> = ({
  gameScore,
  time,
  categories,
  gameState,
}) => {
  const [categoryCounts, setCategoryCounts] = useState<{ [key: string]: number }>({});

  useEffect(() => {
    const counts: { [key: string]: number } = {};

    gameState.questions.forEach(({ category }) => {
      counts[category] = (counts[category] || 0) + 1;
    });
    console.log(counts);

    setCategoryCounts(counts);
  }, [gameState]);
  // console.log("game score in BuildResultsPage", gameScore);

  return (
    <div id="score" className="score-wrap">
      <div className="close-icon" onClick={() => {}}>
        {/* Update the onClick handler as needed */}
      </div>
      <div className="content score">
        <h3 className="title">Results & Stats</h3>
        <div className="scores">
          <div className="time d-flex flex-row justify-content-between">
            <span>Time</span>
            <span className="ng-binding">{buildTime(time)}</span>
          </div>
          {categories.map((category, index) => (
            <div
              className="d-flex flex-row justify-content-between"
              key={index}
              style={{ color: category.color }}
            >
              <div className="memory">{category.title}</div>
              <div className="memory">
                {gameScore[category.title.toLowerCase()] || 0}/
                {categoryCounts[category.title.toLowerCase()] || 10}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const buildTime = (totalSeconds: number) => {
  const totalMs = totalSeconds * 1000;
  const result = new Date(totalMs).toISOString().slice(11, 19);
  return result;
};

export const buildError = (message?: string) => {
  return <h4>{message || "Something went worng"}</h4>;
};

//<div className="rank d-flex flex-row justify-content-between">
// <span>Rank</span>
//  <span>{/* Calculate and display rank */}</span>
// </div>
//  <a href="#results">
//   <button className="scorebtn">Review Statistics</button>
//  </a>
